// Timeline: events in time order (agent runs, activity). Agent events carry the agent chip; refusals show verbatim.
import type { ReactNode } from "react";
import { fmtStamp } from "../lib/format";

export interface TimelineEvent { id: string; at: string; title: ReactNode; detail?: ReactNode; tone?: "agent" | "person" | "refusal" | "system" }

const MARK: Record<NonNullable<TimelineEvent["tone"]>, string> = { agent: "bg-agent", person: "bg-progress", refusal: "bg-blocked", system: "bg-muted" };

export function Timeline({ events, label }: { events: TimelineEvent[]; label: string }) {
  if (!events.length) return <p className="text-sm text-muted">No events yet.</p>;
  return (
    <ol aria-label={label} className="relative space-y-3 border-l border-line pl-4">
      {events.map((e) => (
        <li key={e.id} className="relative">
          <span aria-hidden="true" className={`absolute -left-[21px] top-1.5 h-2.5 w-2.5 rounded-full ring-2 ring-paper ${MARK[e.tone ?? "system"]}`} />
          <div className="flex flex-wrap items-baseline gap-x-2 text-sm">
            <time dateTime={e.at} className="font-mono text-xs text-muted">{fmtStamp(e.at)}</time>
            <span>{e.title}</span>
          </div>
          {e.detail && <div className="mt-0.5 text-xs text-muted">{e.detail}</div>}
        </li>
      ))}
    </ol>
  );
}
